import React from "react";
import T from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { dollars } from "LIB/formatters/currency";
import _, { get } from "lodash";
import { useCurrentUser } from "APP_ROOT/hooks";
import {
  CURRENTLY_TRANSFERRING_STATUSES,
  STATUSES
} from "../../../inventories/constants";
import { NoteTooltip as IconTooltip } from "../NoteTooltip";
import NoteTooltip from "../NoteTooltip/NoteTooltip";

const Badge = ({ consignmentType, consignorCost, tooltip }) => (
  <OverlayTrigger placement="top" overlay={tooltip}>
    <span
      className="badge"
      style={{
        backgroundColor: consignorCost > 0 ? "#cc7a00" : "#757575"
      }}
    >
      {consignmentType === "consignment" ? "CONS" : "EMA"}
    </span>
  </OverlayTrigger>
);

const ConsignmentToolTip = ({ consignmentType, inventory }) => {
  const consignorCost = get(inventory, "consignor_cost");
  const consignmentReference = get(inventory, "consignment_reference");
  const consignorCostTooltip = (
    <Tooltip className="in">{`Cons Ref #: ${consignmentReference} | Consignor Cost is ${dollars(
      consignorCost
    )}.`}</Tooltip>
  );
  const consignmentReferenceTooltip = (
    <Tooltip className="in">{`Cons Ref #: ${consignmentReference}`}</Tooltip>
  );

  if (!consignorCost || consignorCost <= 0) {
    return (
      <Badge
        consignmentType={consignmentType}
        consignorCost={consignorCost}
        tooltip={consignmentReferenceTooltip}
      />
    );
  }

  return (
    <OverlayTrigger placement="top" overlay={consignorCostTooltip}>
      <span
        className="badge"
        style={{
          backgroundColor: consignorCost > 0 ? "#cc7a00" : "#757575"
        }}
      >
        {consignmentType === "consignment" ? "CONS" : "EMA"}
      </span>
    </OverlayTrigger>
  );
};

export default function LocationFlag({
  inventory,
  location,
  transferStatus,
  wareHouseId,
  consignment_type: consignmentType = undefined
}) {
  if (CURRENTLY_TRANSFERRING_STATUSES.includes(transferStatus)) {
    const displayInTransferStatusLabel =
      STATUSES[transferStatus] && STATUSES[transferStatus].label;

    return (
      <IconTooltip
        icon={"fa-2x fa-plane"}
        note={displayInTransferStatusLabel}
        color={"#FFFFFF"}
      />
    );
  }

  if (consignmentType) {
    return (
      <ConsignmentToolTip
        consignmentType={consignmentType}
        inventory={inventory}
      />
    );
  }

  if (!location) return null;

  if (wareHouseId) {
    const wareHouses = _.get(useCurrentUser(), "tenant.ware_houses", []);

    if (wareHouses.length > 0) {
      const wareHouse = wareHouses.find(w => w.id === wareHouseId);

      return (
        <NoteTooltip
          url={`https://info-trader-assets.s3.us-east-2.amazonaws.com/locations/${location}/flag.png`}
          note={wareHouse.name}
          height="auto"
        />
      );
    }
  }

  return (
    <img
      src={`https://info-trader-assets.s3.us-east-2.amazonaws.com/locations/${location}/flag.png`}
      alt={location}
    />
  );
}

LocationFlag.propTypes = {
  location: T.string,
  consignment_type: T.string,
  transferStatus: T.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/LocationFlag/LocationFlag.jsx